import styled from "styled-components"

import {H3} from "@irati/ui/src/Typography"
import {IconTooltip} from "@irati/ui/src/Tooltip"
import ErrorText from "@irati/ui/src/ErrorText"
import Flex from "@irati/ui/src/Flex"

import {StyledCard} from "../../../containers/Reporting/styled"

export const LabelContainer = styled(Flex)`
  margin-bottom: 15px;
`

export const ActivityBlockItem = styled.div`
  padding-right: 65px;
  ${({addLeftPadding}) =>
    addLeftPadding &&
    `
    padding-left: 50px;
`}
`

export const ActivityBlockWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 20px 0 20px;
`

export const StyledTooltip = styled(IconTooltip)`
  padding: 6px 0 3px 5px;
  text-transform: lowercase;
`

export const Error = styled(ErrorText)`
  width: 100%;
`

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({justifyContent}) => justifyContent || "space-between"};
`

export const PillWrapper = styled.div`
  padding-left: 10px;
`

export const ValueContainer = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
`

export const CardWrapper = styled(StyledCard)`
  margin: 30px 0 30px;
`

export const StyledHeader = styled(H3)`
  padding-right: 20px;
`
